import React, { createContext, useContext, useState } from 'react';

const LangContext = createContext({ lang: 'pt', setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('tcm_lang') || 'pt');
  function setLang(l) {
    setLangState(l);
    localStorage.setItem('tcm_lang', l);
  }
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export function useLang() { return useContext(LangContext); }

export const t = {
  pt: {
    hello: 'Olá',
    subtitle: 'Seu plano, treinos e histórico em um só lugar.',
    tabs: { treinos: 'Treinos', dieta: 'Nutrição', historico: 'Histórico', avaliacao: 'Avaliação' },
    planExpired: 'Seu plano venceu.',
    planExpiresSoon: (n) => n === 1 ? 'Seu plano vence amanhã.' : `Seu plano vence em ${n} dias.`,
    renewContact: 'Fale com a equipe para renovar.',
    renew: 'Renovar →',
    noTreino: 'Seu treino ainda não foi cadastrado.\nEm breve a Carol atualiza aqui!',
    noDieta: 'Seu plano alimentar ainda não foi cadastrado.\nA Bárbara atualiza em breve!',
    noCheckin: 'Nenhum check-in registrado ainda.\nFaça seu primeiro treino!',
    proximoSugestao: 'Sugestão para hoje',
    iniciarTreino: 'Iniciar treino',
    pausar: 'Pausar',
    marcarFeito: 'Marcar como feito',
    salvarExercicio: 'Salvar exercício ✓',
    finalizarTreino: '✓ Finalizar treino',
    restantes: (n) => `${n} restante(s)`,
    carolDiz: 'Carol diz:',
    daEquipe: 'Da equipe:',
    daBarbara: 'Da Bárbara:',
    verDemo: 'Ver demonstração',
    refeicoes: 'Refeições',
    exercicios: 'Exercícios',
    agendarAvaliacao: 'Agendar avaliação',
    perfil: 'Perfil',
    sair: 'Sair',
    checkinSalvo: (nome) => `✓ Treino salvo! Ótimo trabalho, ${nome}.`,
    proximo: 'Próximo:',
    sugerido: 'Sugerido',
    calorias: 'Calorias',
    proteina: 'Proteína',
    semana: 'Semana',
    agua: 'Água',
    metaAgua: 'Meta diária',
    suplementacao: 'Suplementação',
    listaCompras: 'Lista de compras',
    substituicoes: 'Opções de substituição',
  },
  en: {
    hello: 'Hello',
    subtitle: 'Your plan, workouts and history in one place.',
    tabs: { treinos: 'Workouts', dieta: 'Nutrition', historico: 'History', avaliacao: 'Assessment' },
    planExpired: 'Your plan has expired.',
    planExpiresSoon: (n) => n === 1 ? 'Your plan expires tomorrow.' : `Your plan expires in ${n} days.`,
    renewContact: 'Contact the team to renew.',
    renew: 'Renew →',
    noTreino: 'Your workout has not been set up yet.\nCarol will update it soon!',
    noDieta: 'Your meal plan has not been set up yet.\nBárbara will update it soon!',
    noCheckin: 'No check-ins recorded yet.\nComplete your first workout!',
    proximoSugestao: "Today's suggestion",
    iniciarTreino: 'Start workout',
    pausar: 'Pause',
    marcarFeito: 'Mark as done',
    salvarExercicio: 'Save exercise ✓',
    finalizarTreino: '✓ Finish workout',
    restantes: (n) => `${n} remaining`,
    carolDiz: 'Carol says:',
    daEquipe: 'From the team:',
    daBarbara: 'From Bárbara:',
    verDemo: 'Watch demo',
    refeicoes: 'Meals',
    exercicios: 'Exercises',
    agendarAvaliacao: 'Schedule assessment',
    perfil: 'Profile',
    sair: 'Sign out',
    checkinSalvo: (nome) => `✓ Workout saved! Great job, ${nome}.`,
    proximo: 'Next:',
    sugerido: 'Suggested',
    calorias: 'Calories',
    proteina: 'Protein',
    semana: 'Week',
    agua: 'Water',
    metaAgua: 'Daily target',
    suplementacao: 'Supplementation',
    listaCompras: 'Shopping list',
    substituicoes: 'Substitution options',
  }
};
